var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGasConsumerUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180-100v-680h190v-80h60v80h100v-80h60v80h190v680H180Zm60-60h480v-560H240v560Zm90-410h300v-60H330v60Zm149.93 316.54q37.45 0 63.38-25.62 25.92-25.61 25.92-61.92 0-29.23-16.95-50.22-16.96-21-72.28-85.32-56.08 64.31-72.65 85.64-16.58 21.33-16.58 49.77 0 36.44 25.86 62.05 25.86 25.62 63.3 25.62ZM240-160v-560 560Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGasConsumerUnitIcon);
export default __webpack_public_path__ + "static/media/marker-gasConsumerUnit-icon.28dc25cb6f43169163cb56051c3fa6a9.svg";
export { ForwardRef as ReactComponent };